import React from 'react';
import CommentProfile from './commentProfile';
import CommentDetails from './commentDetails';

const ViewReplies = ({reply, blogId}) => {
  return (
    <div className="comment-list padd-15">
      {
        reply.map((data, index) => (
          <div className="user-reply" key={blogId +'R'+ index}>
            <CommentProfile 
            profile={data.profile}
            />
            <div className="comment-detail">
              <CommentDetails 
                username={data.username}
                date = {data.date}
                comment = {data.replyMsg}
              />
            </div>
          </div>
        ))
      }
    </div>
  );
};

export default ViewReplies;
